<template>
  <v-container class="pa-0">
    <v-row dense>
      <v-col cols="12">
        <v-skeleton-loader
          v-if="loading"
          type="table-thead,table-tbody"
        ></v-skeleton-loader>
        <v-data-table
          v-else
          :headers="headers"
          :items="responses"
          :search.sync="search"
          :server-items-length="total"
          :options.sync="options"
          :items-per-page="5"
          :footer-props="{
            'items-per-page-options': [5, 10, 25, 50]
          }"
          :expanded.sync="expanded"
          show-expand
          item-key="id"
          @click:row="rowClick"
          class="row-pointer"
          hide-default-footer
        >
          <template v-slot:top="{ pagination, options, updateOptions }">
            <v-row dense>
              <v-col cols="auto">
                <v-text-field
                  class="my-auto mr-4 hideMessages"
                  label="Search by keyword"
                  single-line
                  rounded
                  dense
                  outlined
                  clearable
                  prepend-inner-icon="search"
                  v-model="search"
                  @change="getTextResponses"
                  @click:clear="clearSearch"
                ></v-text-field>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto">
                <v-data-footer
                  :pagination="pagination"
                  :options="options"
                  @update:options="updateOptions"
                  items-per-page-text="$vuetify.dataTable.itemsPerPageText"
                />
              </v-col>
            </v-row>
          </template>
          <template v-slot:item.finishDate="{ item }">
            {{ item.finishDate | normalDate }}
          </template>
          <template v-slot:item.name="{ item }">
            <user-avatar
              v-if="!item.isAnonymous"
              :user="item"
              :size="30"
            ></user-avatar>
            {{ item.name }}
          </template>
          <template v-slot:item.data-table-expand="{ isExpanded }">
            <v-btn text color="info">
              {{ isExpanded ? "Hide Answer" : "View Answer" }}
            </v-btn>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              {{ item.feedback }}
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SurveyTextResults",
  components: {},
  props: {
    questionId: { type: String },
    filter: { type: Object },
    survey: { type: Object }
  },
  data: () => ({
    total: 0,
    expanded: [],
    search: "",
    loading: false,
    options: {},
    headers: [
      {
        text: "Date",
        align: "start",
        value: "finishDate",
        width: "20%"
      },
      { text: "Member Name", value: "name" },
      { text: "", value: "data-table-expand" }
    ]
  }),
  computed: {
    responses() {
      return this.$store.getters["reporting/text_responses"](this.questionId);
    },
    ...mapGetters({})
  },
  watch: {
    options: {
      handler(val, oldVal) {
        if (!this._.isEqual(val, oldVal)) {
          this.getTextResponses();
        }
      },
      deep: true
    },
    filter() {
      this.getTextResponses();
    }
  },
  methods: {
    getTextResponses() {
      this.loading = true;
      this.$store
        .dispatch("reporting/getSurveyTextResponses", {
          pagination: Object.assign(this.options, { search: this.search }),
          questionId: this.questionId,
          surveyId: this.survey.id,
          filter: this.filter || {}
        })
        .then(data => {
          this.total = parseInt(data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rowClick(value) {
      let index = this.expanded.findIndex(x => x == value);
      if (index >= 0) {
        this.expanded.splice(index, 1);
      } else {
        this.expanded.push(value);
      }
    },
    clearSearch() {
      this.search = "";
      this.getTextResponses();
    }
  }
};
</script>

<style lang="scss" scoped>
.v-data-footer {
  border-top: none !important;
}
</style>
